export default {
  "content": "<path d=\"M4.354 15.849l1.04-3.95 2.81-1.13c.17-.07.17-.3 0-.37l-2.81-1.13-1.04-3.95c-.05-.2-.33-.2-.39 0l-1.04 3.95-2.8 1.13c-.17.07-.17.3 0 .37l2.81 1.13 1.04 3.95c.05.2.33.2.39 0h-.01zm5.76-8.95l.67-2.55 1.81-.73c.11-.04.11-.2 0-.24l-1.81-.73-.67-2.55c-.03-.13-.22-.13-.25 0l-.67 2.55-1.81.73c-.11.04-.11.2 0 .24l1.81.73.67 2.55c.03.13.22.13.25 0zm4.05 6.03l.48-1.82 1.3-.52a.09.09 0 000-.17l-1.3-.52-.48-1.82c-.02-.09-.15-.09-.18 0l-.48 1.82-1.3.52a.09.09 0 000 .17l1.3.52.48 1.82c.02.09.15.09.18 0z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};